import PeriodicNameEdit from '@/components/configs/periodicname/edit/PeriodicNameEdit.vue';
import MessageBox from '@/components/common/messagebox/MessageBox.vue'

export default {
  name: 'PeriodicNameList',
  data () {
    return {
      loading: true,
      tableitems: []
    }
  },
  props: {
    modelClassId: {
      default: 0,
      type: String | Number
    },
    modelId: {
      default: null,
      type: String | Number
    }
  },
  components: {
    PeriodicNameEdit,
    MessageBox
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('periodicnames.name'), format: 'formatTranslation' },
        { key: 'tooltip', label: this.$t('periodicnames.tooltip'), format: 'formatTranslation' },
        { key: 'from_date_period_id', label: this.$t('periodicnames.from_date_period_id'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('periodicnames.to_date_period_id'), format: 'formatDatePeriod' }
      ];
      if (this.canEdit) {
        headers.push({
          key: 'actions',
          label: '',
          actions: [
            { label: this.$t('menu.config.periodicnames.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
            { label: this.$t('menu.config.periodicnames.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash' }
          ]
        });
      }
      return headers;
    },
    tableActions () {
      const actions = { };
      if (this.canEdit && this.modelClassId && this.modelId) {
        actions.add = { title: this.$t('menu.config.periodicnames.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    getTableData () {
      const self = this;
      this.loading = true;
      let path = 'periodic-name/list';
      if (this.modelClassId) {
        path += '/' + this.modelClassId;
        if (this.modelId) {
          path += '/' + this.modelId;
        }
      }
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.tableitems = response.data;
        }
        self.loading = false;
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved = 0) {
      if (approved) {
        const path = 'periodic-name/deleted';
        const self = this;
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { id: el.id, deleted: 1 }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$store.dispatch('reloadConfig', { force: true });
            self.getTableData();
          }
        });
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('menu.config.periodicnames.deleteTitle'), this.$t('menu.config.periodicnames.deleteMessage', el))
      }
    }
  },
  mounted () {
    this.getTableData();
  }
}
